import React, { useState, useContext } from "react"

import styles from './Hijo.module.css'
import btnEditar from '../../img/btneditar.png'
import btnEliminar from '../../img/btneliminar.png'
import GeneralContext from '../../context/GeneralContext'
import Modal from '../Modals'
import AgregarHijo from '../AgregarHijo'

//Services
import * as Services from '../../utils/services'
import * as Funciones from "../../utils/funciones";
import * as Constantes from "../../utils/constantes";

const ItemHijo = ({ state, setState, family, pFamilia, recargarLista }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]
    const textos = ['Eliminar Hijo', '¿Estás seguro de eliminar hijo?']

    function converti(cadena) {
        return cadena.charAt(0).toUpperCase() + cadena.slice(1)
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }    

    const [ mostrarHijoModal, setMostrarHijoModal ] = useState(false)
    const [ mostrarConfirmacionModal, setMostrarConfirmacionModal ] = useState(false)

    const abrirHijoModal = (hijo) => {
        let hijoAux = null
        if (hijo !== null) {
            hijoAux = hijo
        } else {
            hijoAux = null
    }
        setMostrarHijoModal(true)

        setState((state) => {
            return {
                ...state,
                hijoSeleccionado: hijoAux,
                modalInsertar: true
            }
        })
    }

    const eliminarHijo = async () => {
        const invocarDeleteFamiliares = async () => {
            setState((state) => {
                return {
                    ...state,
                    estaCargando: true
                }
            })

            const resDeleteFamiliar = await Services.deleteFamiliaresId(user, cotizacion.idSolicitudMultiple, state.hijoSeleccionado?.idFamiliar)
            if (!resDeleteFamiliar.error) {
                setState((state) => {
                    return {
                        ...state,
                        estaCargando: false,
                        hijoSeleccionado: null
                    }
                })
                await recargarLista()
                return Promise.resolve('ok')
            } else {
                setState((state) => {
                    return {
                        ...state,
                        estaCargando: false,
                      hijoSeleccionado: null,
                      errorCargando: resDeleteFamiliar.mensajeError
                    }
                })
                return Promise.reject()
        }
    }

        await invocarDeleteFamiliares()
    }
    
    const confirmarEliminarHijo = (hijo) => {
        setMostrarConfirmacionModal(!mostrarHijoModal)
        setState((state) => {
            return {
                ...state,
                hijoSeleccionado: hijo,
                modalBorrar: !mostrarHijoModal
            }
        })
    }

    return (
        <React.Fragment>
            <AgregarHijo
                mostrarModal={mostrarHijoModal}
                setModal={setMostrarHijoModal}
                state={state}
                setState={setState}
                pFamiliar={pFamilia}
                recargarLista={recargarLista}
            />
            <Modal
                mostrarModal={mostrarConfirmacionModal}
                setModal={setMostrarConfirmacionModal}
                doble={true}
                textos={textos}
                accion={() => eliminarHijo()}
            />
            <p className={styles['area-datos-prospecto-subtitulo2']}>Sobre tu(s) hijo(s)</p>
            <div className={styles['area-datos-prospecto-accion']}>
                <div>
                    <button 
                        className={Deshabilitar() !== true ? styles['btn-insertar'] : styles['btn-insertar-inhabilitar']} 
                        onClick={Deshabilitar() !== true ? (e) => abrirHijoModal(null) : null}
                    >
                        <span>+</span>Insertar
                    </button>
                </div>
                <div className={styles['area-datos-prospecto-accion-barra']}>
                </div>
            </div>
            <div className={styles['data-grid-prospecto']}>
                <div className={styles['data-grid-head']}>
                    <div className={styles['data-grid-row-head1']}>
                        <div className={styles['data-grid-head-item']}>Tipo Doc.</div>
                        <div className={styles['data-grid-head-item']}>Nro. Doc.</div>
                        <div className={styles['data-grid-head-item']}>Nombres</div>
                        <div className={styles['data-grid-head-item']}>Ap. Paterno</div>
                        <div className={styles['data-grid-head-item']}>Ap. Materno</div>
                        <div className={styles['data-grid-head-item']}>Sexo</div>
                        <div className={styles['data-grid-head-item']}>Ocupación</div>
                        <div className={styles['data-grid-head-item']}>Fec. Nacimiento</div>
                        <div className={styles['data-grid-head-item']}></div>
                    </div>
                    {!state.campoValidado.cantidadH ? 
                        <div className={styles['errorHijos']}>
                            Debes registrar los datos de al menos un hijo.
                        </div>
                : null}
                </div>
            </div>
            <div>
                {(family && family.length > 0) && family.map((hijo, index) => {
                    return (
                        <div key={index} className={styles['data-grid-body']}>
                            <div className={!state.campoValidado.sexoH && hijo.sexo === null ? styles['error'] : styles['data-grid-row-body1']}>
                                <div className={`${styles['data-grid-body-item']} ${styles['item-top']}`}>
                                    {hijo.tipoDocumento && hijo.tipoDocumento?.descripcion}
                                </div>
                                <div className={`${styles['data-grid-body-item']} ${styles['item-top']}`}>
                                    {hijo.numeroDocumento}
                                </div>
                                <div className={`${styles['data-grid-body-item']} ${styles['item-top']}`}>
                                    {converti(hijo.nombres && hijo.nombres.toLowerCase())}
                                </div>
                                <div className={`${styles['data-grid-body-item']} ${styles['item-top']}`}>
                                    {converti(hijo.apellidoPaterno && hijo.apellidoPaterno.toLowerCase())}
                                </div>
                                <div className={`${styles['data-grid-body-item']} ${styles['item-top']}`}>
                                    {converti(hijo.apellidoMaterno && hijo.apellidoMaterno.toLowerCase())}
                                </div>
                                <div className={`${styles['data-grid-body-item']} ${styles['item-top']}`}>
                                    {hijo.sexo !== null && hijo.sexo.codigo === 1 ? 'M' : hijo.sexo !== null && hijo.sexo.codigo === 0 ? 'F' : ''}
                                </div>
                                <div className={`${styles['data-grid-body-item']} ${styles['item-top']}`}>
                                    {hijo.ocupacion && hijo.ocupacion.descripcion}
                                </div>
                                <div className={`${styles['data-grid-body-item']} ${styles['item-top']}`}>
                                    {hijo !== null && hijo.fechaNacimiento !== '1901-01-01'
                                        ? Funciones.transformarStringFechaToFormato(hijo.fechaNacimiento, Constantes.FORMATO_FECHA_1) : ''}
                                </div>
                                <div className={styles['data-grid-body-item']}>
                                    <img className={styles['btn-grid']} src={btnEditar} alt="" onClick={(e) => abrirHijoModal(hijo)} 
                                        style={{pointerEvents: Deshabilitar() !== true ? "auto" : "none"}}
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <img className={styles['btn-grid']} src={btnEliminar} alt="" onClick={(e) => confirmarEliminarHijo(hijo)} 
                                        style={{pointerEvents: Deshabilitar() !== true ? "auto" : "none"}}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </React.Fragment>
    )
}

export default ItemHijo